import React from "react";

const BS5_GridSystem = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridSystem Component</h2>
      <p>This is the BS5_GridSystem component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridSystem;
